import { RowsSkeleton } from './Rows';
import { TitleSkeleton } from './Title';

export const PaymentPageSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="px-[8px]">
        {/* amount section */}
        <TitleSkeleton height={18} />
        <TitleSkeleton height={38} />
        {/* summary info */}
        <RowsSkeleton rowHeight={60} />
        {/* payment block */}
        <RowsSkeleton rowHeight={228} />
      </div>
    </div>
  );
};
